const TIER_STYLES = {
  bronze: 'bg-amber-100 text-amber-800 border-amber-300',
  silver: 'bg-slate-100 text-slate-700 border-slate-300',
  gold: 'bg-yellow-100 text-yellow-800 border-yellow-400',
};

const TIER_LABELS_TR = {
  bronze: 'Bronz',
  silver: 'Gümüş',
  gold: 'Altın',
};

const TIER_LABELS_EN = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
};

const TIER_I18N_KEYS = {
  bronze: 'tierBronze',
  silver: 'tierSilver',
  gold: 'tierGold',
};

export function getMembershipTierLabel(tier, locale = 'tr', t = null) {
  if (!tier) return null;
  const key = String(tier).toLowerCase();
  if (t && TIER_I18N_KEYS[key]) {
    const translated = t(`membership.${TIER_I18N_KEYS[key]}`);
    if (translated && !translated.startsWith('membership.')) {
      return translated;
    }
  }
  const labels = locale === 'tr' ? TIER_LABELS_TR : TIER_LABELS_EN;
  return labels[key] || tier;
}

export function getMembershipTierDisplayName(tier, config, t, lang) {
  if (t && TIER_I18N_KEYS[tier]) {
    const translated = t(`membership.${TIER_I18N_KEYS[tier]}`);
    if (translated && !translated.startsWith('membership.')) {
      return translated;
    }
  }
  if (lang === 'tr') return config?.name_tr || config?.name || tier;
  return config?.name || config?.name_tr || tier;
}

export function getMembershipTierFeatures(tier, config, t, lang) {
  const fromI18n = t(`membership.features.${tier}`, { returnObjects: true });
  if (Array.isArray(fromI18n) && fromI18n.length > 0 && typeof fromI18n[0] === 'string') {
    return fromI18n;
  }
  if (lang === 'tr') return config?.features || [];
  return config?.features_en || config?.features || [];
}

export function getMembershipTierStyle(tier) {
  if (!tier) return 'bg-gray-100 text-gray-600';
  return TIER_STYLES[String(tier).toLowerCase()] || 'bg-gray-100 text-gray-600';
}

export function getMembershipStatusLabel(status, t) {
  if (!status) return t('admin.noMembership', 'Üyelik yok');
  const map = {
    active: t('admin.statusActive', 'Aktif'),
    expired: t('admin.statusExpired', 'Süresi Dolmuş'),
    cancelled: t('admin.statusCancelled', 'İptal Edilmiş'),
    past_due: t('admin.statusPastDue', 'Ödeme gecikmiş'),
  };
  return map[status] || status;
}

export function resolveMembershipError(detail, t) {
  const code = typeof detail === 'string' ? detail : '';
  const map = {
    membership_payment_unavailable: t('membership.paymentUnavailable'),
    membership_already_active: t('membership.alreadySubscribed'),
    invalid_membership_tier: t('membership.invalidTier'),
    invalid_billing_period: t('membership.invalidBillingPeriod'),
    'Authentication required': t('membership.loginRequired'),
    'You already have an active subscription': t('membership.alreadySubscribed'),
  };
  if (map[code]) return map[code];
  if (code.toLowerCase().includes('internal server error')) {
    return t('membership.paymentUnavailable');
  }
  return code || t('membership.subscribeFailed');
}
